export default {"src":"/_next/static/media/globe.e336237f.svg","height":24,"width":24};